import { useRef } from "react";
import ModalPop from "./ModalPop";
import useDeviceType from "../common/useDeviceType";

const Event = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  const isMobile = useDeviceType();
  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />

      <div className=" relative w-full h-full bg-[url('../public/images/eventBg.webp')] bg-fixed bg-cover bg-center">
        <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto pt-14 lg:pt-28 xl:pt-36">
          <img
            src={isMobile ? "/images/evnetTxtM.webp" : "/images/evnetTxt.webp"}
            alt="곰팡이 제거 및 재오염 방지"
          />
        </div>
      </div>
    </>
  );
};

export default Event;
